import { Injectable } from '@angular/core';
import {
  ContainerItemModel,
  ContainerItemOption,
  ContainerModel,
} from '@app/models/server/layout.model';
import { SelectedItem } from '@app/models/client/item.model';
// import { LoggerService } from '@app/services/util-services/logger.service';
import { UID_CONSTANTS } from '@app/constants/forms.constants';
import { StringUtilLibService } from '@b2b/string-util-lib';
import { DayjsDateUtilLibService } from '@b2b/date-util-lib';

@Injectable()
export class FormHelperService {
  constructor(
    private stringUtilLibService: StringUtilLibService,
    private dayjsDateUtilLibService: DayjsDateUtilLibService,
  ) {}

  getFormDisplayValue(
    selectedValue: SelectedItem,
    container: ContainerModel,
    containerItem: ContainerItemModel,
  ):
    | {
        label1: string;
        label2?: string;
        label3?: string;
        label4?: string;
        label5?: string;
        label6?: string;
        label7?: string;
        label8?: string;
      }
    | string {
    switch (containerItem?.name) {
      case UID_CONSTANTS.DESTINATION_AUTOCOMPLETE:
        return this.stringUtilLibService.toTitleCase(selectedValue?.title);
      case UID_CONSTANTS.CHECKIN_DATE_DATEPICKER:
        return {
          label1: selectedValue?.value?.date,
          label2: selectedValue?.value?.displayMonth,
          label3: selectedValue?.value?.years,
          label4: selectedValue?.value?.displayDay,
        };
      case UID_CONSTANTS.CHECKIN_CHECKOUT_DATEPICKER:
        return {
          label1: selectedValue?.value?.from?.date,
          label2: selectedValue?.value?.from?.displayMonth,
          label3: selectedValue?.value?.from?.years,
          label4: selectedValue?.value?.from?.displayDay,
          label5: selectedValue?.value?.to?.date,
          label6: selectedValue?.value?.to?.displayMonth,
          label7: selectedValue?.value?.to?.years,
          label8: selectedValue?.value?.to?.displayDay,
        };
      case UID_CONSTANTS.CHECKIN_TIME:
        if (selectedValue?.title) {
          const values: string[] = selectedValue?.title?.split(' ');
          if (values?.length === 2) {
            return {
              label1: this.stringUtilLibService.toTitleCase(values[0]),
              label2: this.stringUtilLibService.toTitleCase(values[1]),
            };
          }
        }
        return { label1: undefined, label2: undefined };
      case UID_CONSTANTS.HOUR:
        if (selectedValue?.title) {
          const values: string[] = selectedValue?.title?.split(' ');
          if (values?.length === 2) {
            return {
              label1: this.stringUtilLibService.toTitleCase(values[0]),
              label2: this.stringUtilLibService.toTitleCase(values[1]),
            };
          }
        }
        return { label1: undefined, label2: undefined };
      case UID_CONSTANTS.NEW_ROOM_GUEST_PICKER:
        if (selectedValue?.value?.totalRooms > 0) {
          return {
            label1: selectedValue?.value?.totalRooms,
            label2: 'Room',
            label3: selectedValue?.value?.totalAdults,
            label4: 'Adult',
            label5:
              selectedValue?.value?.totalChildrenCount > 0
                ? selectedValue?.value?.totalChildrenCount
                : undefined,
            label6: 'Children',
          };
        }
        return {
          label1: undefined,
          label2: undefined,
          label3: undefined,
          label4: undefined,
          label5: undefined,
          label6: undefined,
        };

      case UID_CONSTANTS.NEW_GUEST_PICKER:
        if (selectedValue?.value?.totalRooms > 0) {
          return {
            label1: selectedValue?.value?.totalAdults,
            label2: 'Guest',
          };
        }
        return {
          label1: undefined,
          label2: undefined,
        };

      default:
        return undefined;
    }
  }

  validate(
    validator,
    config: {
      options: ContainerItemOption[];
      dependOnFieldNewValue: any;
      currentFieldValue: SelectedItem;
    },
  ): any {
    switch (validator) {
      case 'checkinTimeOptionsValidator':
        // return this.checkinTimeOptionsValidator(config);
        // TODO: need to fix return null in case of validate checkin time options
        return null;
      case 'hourOptionsValidator':
        return this.hourOptionsValidator(config);
    }
  }

  /**
   * Validate hours option
   *
   */
  hourOptionsValidator(config: {
    options: ContainerItemOption[];
    dependOnFieldNewValue: ContainerItemOption;
    currentFieldValue: SelectedItem;
  }): {
    currentFieldValue: SelectedItem;
  } {
    // LoggerService.log('Inside hourOptionsValidator ');

    // let ishourOptionsAvailable: boolean = Boolean(false);
    for (const hourOption of config.options) {
      const hour: number = Number(hourOption?.value);
      // LoggerService.log('hourOption ', hourOption);
      if (config?.dependOnFieldNewValue?.minimumHourBooking > hour) {
        // disabled option
        hourOption.disabled = true;
      } else {
        hourOption.disabled = false;
      }
    }

    // LoggerService.log('config.options ', config.options);

    // Reset hour options
    if (config.options) {
      for (const hourOption of config.options) {
        if (hourOption.value === config?.currentFieldValue?.value?.value) {
          if (hourOption.disabled) {
            config.currentFieldValue = undefined;
          }
        }
      }
    }

    return {
      currentFieldValue: config.currentFieldValue,
    };
  }

  /**
   * Validate checkin time options
   * @param config
   */
  /*  checkinTimeOptionsValidator(config: {
      options: ContainerItemOption[];
      dependOnFieldNewValue: SelectedDateModel;
      currentFieldValue: SelectedItem;
    }): {
      currentFieldValue: SelectedItem;
    } {
      // LoggerService.log(' this.checkinTimeOptions.list ', config?.options);

      for (const checkinTimeOption of config?.options) {
        if (
          this.dateUtilService.isValidCheckInTimeOption(
            config?.dependOnFieldNewValue?.dateObj,
            checkinTimeOption
          )
        ) {
          checkinTimeOption.disabled = false;
        } else {
          checkinTimeOption.disabled = true;
          if (
            config?.currentFieldValue?.value?.title === checkinTimeOption.title
          ) {
            config.currentFieldValue = undefined;
          }
        }
      }
      return {
        currentFieldValue: config.currentFieldValue,
      };
    }*/
}
